import { type ChangeEvent, type ReactNode } from 'react';
import { type IFloatingFilterParams } from '@ag-grid-community/core';
import { useSearchParams } from 'react-router-dom';
import { useCustomNumberFilter } from './common';

export default function NumberFilter(props: IFloatingFilterParams): ReactNode {
    const { filterValue, setFilterValue } = useCustomNumberFilter(props);
    useSearchParams();

    function onTextChanged(event: ChangeEvent<HTMLInputElement>): void {
        const numberValue = Number(event.target.value);
        if (isNaN(numberValue)) {
            return;
        }
        setFilterValue(numberValue);
    }

    return (
        <div className="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper">
            <input
                className="ag-input-field-input ag-text-field-input"
                type="number"
                value={filterValue ?? ''}
                onChange={onTextChanged}
            />
        </div>
    );
}
